module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Birmenstorf-6efbd33d72769bf612270d9c9344fe94.svg";